export default __webpack_public_path__ + "static/media/realEstate@2x.fded6a08.png";